export function index(jobId)
{
    return axios.get(route('api.manage.jobs.jobAttachments', { jobId: jobId }))
        .then(response => response.data);
}

export function store(jobId, data)
{
    return axios.post(route('api.manage.jobs.jobAttachments.store', {jobId}), data)
        .then(response => response.data);
}

export function destroy(attachmentId)
{
    return axios.delete(route('api.manage.jobAttachments.destroy', { attachmentId: attachmentId }));
}

export function destroyNewsletterTemplate(attachmentId)
{
    return axios.delete(route('api.manage.emailTemplateAttachments.destroy', { attachmentId: attachmentId }));
}
